import axiosCoralie from "../axios-setup";

const CONF = window?.confPub;
const ROUTES = CONF?.ROUTES
const MNH_ENVOI_MAIL = CONF?.ROUTES?.ENVOI_MAIL

export const postNouveauxAyantsDroit = async (emailCorrespondant, detailPersonne, dateEffet, nouveauxAyantsDroit, files) => {

    let formData = new FormData();
    formData.append("emailCorrespondant", emailCorrespondant)

    formData.append("numContratMp", detailPersonne?.contrat?.[0]?.numeroContrat)
    formData.append("nomMp", detailPersonne?.nom)
    formData.append("prenomMp", detailPersonne?.prenom)

    formData.append("dateEffet", dateEffet)
    formData.append("nouveauxAyantsDroit", nouveauxAyantsDroit)

    files.forEach((file, index) => {
        formData.append(`files`, file);
    });

    const url = ROUTES?.ENVOI_MAIL?.AJOUT_AYANT_DROITS

    try {
        return await axiosCoralie.post(url,
            formData,
            {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            })

    } catch (err) {

        console.error('Erreur lors de l\'envoi des données', err);
        alert('Échec de l\'envoi des données');
        throw err;
    }
}

export const changementNom = async (idGrm, emailCorrespondant, detailPersonne, contratBeneficiaire, nouveauNom, documentJustificatif) => {

    let formData = new FormData();
    formData.append("idGrm", idGrm)
    formData.append("emailCorrespondant", emailCorrespondant)

    formData.append("numContratMp", detailPersonne?.contrat?.[0]?.numeroContrat)
    formData.append("nomMp", detailPersonne?.nom)
    formData.append("prenomMp", detailPersonne?.prenom)

    formData.append("nom", contratBeneficiaire?.nom)
    formData.append("prenom", contratBeneficiaire?.prenom)
    formData.append('dateNaissance', contratBeneficiaire?.dateNaissance)
    formData.append('nouveauNom', nouveauNom)
    formData.append('file', documentJustificatif)

    const url = ROUTES?.ENVOI_MAIL?.CHANGEMENT_NOM

    try {
        return await axiosCoralie.post(url,
            formData,
            {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            })

    } catch (err) {

        console.error('Erreur lors de l\'envoi des données', err);
        alert('Échec de l\'envoi des données');
        throw err;
    }
}

export const postFormulaire = async (form, url) => {

    console.log("url")
    console.log(url)
    for (let [key, value] of form.entries()) {
        console.log(`${key}: ${value}`);
    }

    try {
        const resp = await axiosCoralie.post(url,
            form,
            {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            })

        console.log("postChangementContratOld : ", resp)

        return resp

    } catch (err) {

        console.error('Erreur lors de l\'envoi des données', err);
        alert('Échec de l\'envoi des données');
        throw err;
    }
}